const ALWAYS_HIDDEN_IDS = ['digital', '_pm_preview']

// Strikte feste Plätze (Team-Entscheid 2026-07-30): Sprache (languageAttributes
// aus front config.json) und Format (2D/3D) stehen IMMER auf der Border über
// der Zeit-Pille, ALLES andere (Atmos, HDR, Neustart, …) IMMER als Text
// darunter. Kein Auffüllen der Border — Infos springen nie zwischen oben und
// unten und finden sich immer an der bekannten Stelle.
const FORMAT_IDS = ['2d', '3d', '1087', '1088', 'filmtype_2', 'filmtype_3']
const SUPPRESSED_2D_IDS = ['2d', '1087', 'filmtype_2']
const IDS_3D = ['3d', '1088', 'filmtype_3']

const separateNewsletterAttributes = (attributes, hiddenAttributes, languageAttributes) => {
  const hidden = hiddenAttributes || []
  const languages = languageAttributes || []

  const cleaned = (attributes || [])
    .filter(a => a && a.id != null)
    .map(a => ({ id: String(a.id).trim(), name: a.name }))
    .filter(a => !ALWAYS_HIDDEN_IDS.includes(a.id) && !hidden.includes(a.id))

  const isBorderId = (id) => languages.includes(id) || FORMAT_IDS.includes(id)
  const border = cleaned.filter(a => isBorderId(a.id))
  const below = cleaned.filter(a => !isBorderId(a.id))

  // 2D bleibt implizit (Front-Regel): nur zusammen mit 3D wird es gelabelt
  const has3D = border.some(a => IDS_3D.includes(a.id))
  const borderFiltered = border.filter(a => !SUPPRESSED_2D_IDS.includes(a.id) || has3D)

  const byName = (a, b) => String(a.name).localeCompare(String(b.name))
  // Sprache vor Format — die wichtigste Information steht vorn
  const byLanguageFirst = (a, b) => {
    const langDiff = Number(languages.includes(b.id)) - Number(languages.includes(a.id))
    return langDiff !== 0 ? langDiff : byName(a, b)
  }
  return {
    border: borderFiltered.sort(byLanguageFirst),
    below: below.sort(byName)
  }
}

export default separateNewsletterAttributes
